/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Error_Editing_Audio_NoteInputs */

const en_mobile_error_editing_audio_note = /** @type {(inputs: Mobile_Error_Editing_Audio_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error editing audio note`)
};

const es_mobile_error_editing_audio_note = /** @type {(inputs: Mobile_Error_Editing_Audio_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al editar la nota de audio`)
};

/**
* | output |
* | --- |
* | "Error editing audio note" |
*
* @param {Mobile_Error_Editing_Audio_NoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_error_editing_audio_note = /** @type {((inputs?: Mobile_Error_Editing_Audio_NoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Error_Editing_Audio_NoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_error_editing_audio_note(inputs)
	return en_mobile_error_editing_audio_note(inputs)
});